import store, { pauseRouter } from './store';
import platformName from './public-platform';

const postMessage = callback => {
    if (!callback || typeof callback !== 'function') return;
    window.onmessage = e => {
        callback(e);
    };
};

const apps = platformName.map(item => {
    return {
        name: item.platformName,
        entry: process.env[`VUE_APP_SUB_${item.shortName.toUpperCase()}`],
        activeRule: `/any/${item.shortName}/`,
        container: '#subapp-viewport', // 子应用挂载的div
        props: {
            routerBase: `/any/${item.shortName}/`, // 下发基础路由,
            getGlobalState: store.getGlobalState, // 下发getGlobalState方法
            postMessage,
            pauseRouter
        }
    };
});

const microFullScreenApp = platformName.map(item => {
    return {
        name: item.platformName + '-full-screen',
        entry: process.env[`VUE_APP_SUB_${item.shortName.toUpperCase()}`],
        activeRule: `/micro-app-full-screen/${item.shortName}/`,
        container: '#micro-app', // 子应用挂载的div
        props: {
            routerBase: `/micro-app-full-screen/${item.shortName}/`, // 下发基础路由,
            getGlobalState: store.getGlobalState // 下发getGlobalState方法
        }
    };
});

export default [...apps, ...microFullScreenApp];
